<div class="w-full h-full inline-block align-middle">
  <div class="grid grid-cols-1 pt-4 pb-8">
      <h3 class="text-center my-8">
        {{error.error}}
      </h3>
      <p class="w-100 text-center text-lg my-3"> {{error.errorDescription}}</p>
  </div>
</div>
